import { defaultThemeVariables } from './default-theme-variables';
import { color } from './variable-constants';

export const myvmThemeVariables = {
  ...defaultThemeVariables,
  '--secondary-color': color.metallicSeaweed
};
